import { Button, Modal } from "antd";
import dayjs from "dayjs";
import { useState } from "react";
import { useIntl } from "react-intl";
import {
  deleteSVG,
  editSVG,
  emailSVG,
  phoneSVG,
} from "../../../assets/clients/SVGs";
import PopAddNewClient from "../../clients/PopAddNewClient";
import GenderSwitch from "../../common/GenderSwitch";

export default function ClientRowData({
  data,
  showDeleteModal,
  idDelete,
}: any) {
  const intl = useIntl();
  const [editClientModal, setEditClientModal] = useState(false);
  const [dataClientModal, setDataClientModal] = useState(data);
  const handleCloseClient = () => {
    setEditClientModal(false);
  };
  const handleShowClient = () => {
    setEditClientModal(true);
  };

  return (
    <>
      <Modal
        width="80%"
        open={editClientModal}
        onCancel={handleCloseClient}
        footer={null}
      >
        <PopAddNewClient
          close={handleCloseClient}
          clientId={dataClientModal?.id}
          dataClientModal={dataClientModal}
        />
      </Modal>
      <div className="flex flex-col w-full items-center gap-4 py-4 bg-[#FBFBFF] px-5 mt-2 rounded-md">
        <div className="flex items-center justify-between w-full ">
          <span className="capitalize">
            {intl.formatMessage({
              id: "customerNameTap",
            })}{" "}
            {data?.first_name} {data?.last_name}
          </span>
          <div className="flex items-center gap-4">
            <Button
              onClick={() => handleShowClient()}
              type="primary"
              className="btn-primary-edit"
            >
              {editSVG}
              {intl.formatMessage({
                id: "edit_client",
              })}
            </Button>
            <Button
              type="primary"
              onClick={() => showDeleteModal()}
              className="btn-primary-danger"
            >
              {deleteSVG}
              {intl.formatMessage({
                id: "deleteClient",
              })}
            </Button>
          </div>
        </div>
        <div className="flex items-center justify-start w-full gap-2 ">
          <span className="text-sm">
            {intl.formatMessage({
              id: "prefer_to_book_with",
            })}{" "}
          </span>
          <GenderSwitch
            disabled
            active={true}
            gender={data?.preferred_staff_gender}
            string={data?.preferred_staff_gender}
          />
        </div>
        <div className="flex items-center justify-between w-full px-6 py-3 bg-white rounded-md">
          <span className="flex items-center gap-1">
            {phoneSVG} <span dir="ltr">{data?.phone}</span>{" "}
          </span>
          <span className="flex items-center gap-1">
            {emailSVG} {data?.email}
          </span>
        </div>
        <div className="flex items-center justify-between w-full px-6 py-3 bg-white rounded-md">
          <span className="flex items-center gap-1 font-semibold text-gray-300">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              className="flex items-center"
            >
              <path
                d="M6.66683 2.01172C6.39068 2.01172 6.16683 1.78786 6.16683 1.51172C6.16683 1.23558 6.39068 1.01172 6.66683 1.01172H9.02385C9.29999 1.01172 9.52385 1.23558 9.52385 1.51172C9.52385 1.78786 9.29999 2.01172 9.02385 2.01172H6.66683Z"
                fill="#9999A7"
              />
              <path
                d="M4.35372 2.31299C4.54898 2.50825 4.54898 2.82483 4.35372 3.02009L2.68705 4.68676C2.49179 4.88202 2.1752 4.88202 1.97994 4.68676C1.78468 4.4915 1.78468 4.17492 1.97994 3.97965L3.64661 2.31299C3.84187 2.11773 4.15845 2.11773 4.35372 2.31299Z"
                fill="#9999A7"
              />
              <path
                d="M8.00016 3.83321C5.33079 3.83321 3.16683 5.99716 3.16683 8.66654C3.16683 11.3359 5.33079 13.4999 8.00016 13.4999C10.6695 13.4999 12.8335 11.3359 12.8335 8.66654C12.8335 8.3904 13.0574 8.16654 13.3335 8.16654C13.6096 8.16654 13.8335 8.3904 13.8335 8.66654C13.8335 11.8882 11.2218 14.4999 8.00016 14.4999C4.7785 14.4999 2.16683 11.8882 2.16683 8.66654C2.16683 5.44488 4.7785 2.83321 8.00016 2.83321C8.27631 2.83321 8.50016 3.05707 8.50016 3.33321C8.50016 3.60935 8.27631 3.83321 8.00016 3.83321Z"
                fill="#9999A7"
              />
              <path
                d="M11.459 5.57605C11.6138 5.377 11.5961 5.09383 11.4178 4.91552C11.2395 4.73722 10.9564 4.71959 10.7573 4.8744L8.64405 6.51805L7.2631 7.50445C6.96812 7.71515 6.79305 8.05534 6.79305 8.41784C6.79305 9.03776 7.2956 9.54031 7.91553 9.54031C8.27803 9.54031 8.61822 9.36524 8.82892 9.07026L9.81531 7.68932L11.459 5.57605Z"
                fill="#9999A7"
              />
            </svg>
            {intl.formatMessage({
              id: "clients_since",
            })}{" "}
            <span className="font-medium text-black ">
              {dayjs(data?.created_at).format("DD-MM-YYYY")}
            </span>
          </span>
          {/* <span className="flex items-center gap-1 text-gray-300">
      {locationSVG}{" "}
      {intl.formatMessage({
        id: "branch",
      })}
      :
      <span className="flex items-center gap-1 text-black">
        نور مشروع - جدة
      </span>
    </span> */}
        </div>
        {/* <div className="flex items-center justify-between w-full px-6 py-3 bg-white rounded-md">
          <span className="flex items-center gap-1 text-gray-300">
            {pinedSVG}
            {intl.formatMessage({
              id: "comments",
            })}
            : <span className="flex items-center gap-1 text-black">....</span>
          </span>
        </div> */}
      </div>
    </>
  );
}
